import { ENV_APP_PROJECT } from '@apps-common/lib/environment'
import { useMemo } from 'react'

const project = ENV_APP_PROJECT

export const useProjectHook = (portalHook: any, mmHook: any) => {
  const hook = useMemo(() => {
    if (project === 'my-monitoring') {
      return mmHook
    }

    return portalHook
  }, [])

  return hook
}
